import { getUnionValues, type UnionRecord } from '../validation'

const caseStatusValues: UnionRecord<CaseStatus> = {
  APPLICATION_SUBMITTED: null,
  AWAITING_OFFER: null,
  AWAITING_VALUATION: null,
  COMPLETE: null,
  LEAD: null,
  EXCHANGE: null,
  IMPORTING: null,
  INVALID_STATUS: null,
  OFFER_RECEIVED: null,
  POST_RECOMMENDATION_REVIEW: null,
  PRE_APPLICATION: null,
  PRE_RECOMMENDATION: null,
  REFERRED: null,
  NOT_PROCEEDING: null,
  REVIEW: null,
  IMPORTED_COMPLETE: null,
  POST_APPLICATION: null,
}

export default getUnionValues(caseStatusValues)
